import { ChangeDetectorRef, Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { BehaviorSubject, combineLatest, Subscription } from 'rxjs';
import { AuthService, isDriver } from '../root/auth.service';

@Directive({
  selector: '[lohiIsDriver]',
})
export class IsDriverDirective implements OnDestroy {
  private hasView = false;
  private hasElseView = false;
  private elseTemplate$$ = new BehaviorSubject<TemplateRef<any>>(null);
  private subscription: Subscription;

  @Input() public lohiIsDriver: any;

  @Input() public set lohiIsDriverElse(elseTemplate: TemplateRef<any>) {
    this.elseTemplate$$.next(elseTemplate);
  }

  constructor(
    private authService: AuthService,
    private cd: ChangeDetectorRef,
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<any>,
  ) {
    this.setup();
  }

  public ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private setup() {
    this.subscription = combineLatest([this.authService.userInfo$, this.elseTemplate$$]).subscribe(
      ([userInfo, elseTemplate]) => {
        if (isDriver(userInfo)) {
          if (!this.hasView) {
            if (this.hasElseView) {
              this.viewContainer.clear();
              this.hasElseView = false;
            }
            this.viewContainer.createEmbeddedView(this.templateRef);
            this.hasView = true;
            this.cd.markForCheck();
          }
        } else {
          if (this.hasView) {
            this.viewContainer.clear();
            this.hasView = false;
            this.cd.markForCheck();
          }
          if (elseTemplate && !this.hasElseView) {
            this.viewContainer.createEmbeddedView(elseTemplate);
            this.hasElseView = true;
            this.cd.markForCheck();
          }
          return;
        }
      },
    );
  }
}
